const cloudflareConfig = {
    turnstile: {
        scriptURL: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
        sitekey: process.env.VUE_APP_CF_TURNSTILE_SITE_KEY,
        theme: 'light',
        appearance: 'interaction-only'
    }
}

export default cloudflareConfig;
